module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Chart-line2-fb72b57efd9682a32b82ed8f10c31bd4.svg";